"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var Types_1 = require("../../../../../Types");
var reactstrap_date_picker_1 = require("reactstrap-date-picker");
var HistoryFilters = /** @class */ (function (_super) {
    __extends(HistoryFilters, _super);
    function HistoryFilters(props) {
        var _this = _super.call(this, props) || this;
        _this.getDate = function (offset, date) {
            if (offset === void 0) { offset = 0; }
            if (date === void 0) { date = new Date(); }
            date.setDate(new Date().getDate() + offset);
            return date.toISOString();
        };
        _this.onChangeHandler = function (event) {
            var id = event.currentTarget.id;
            var value = event.currentTarget.id == "AlertFilter" ? event.currentTarget.checked : event.currentTarget.value;
            _this.setState(function (prevState) {
                var _a;
                return {
                    filters: __assign(__assign({}, prevState.filters), (_a = {}, _a[id] = value, _a))
                };
            }, function () {
                if (!_this.searchInProgress) {
                    _this.requestResults();
                }
            });
        };
        _this.dateOnChange = function (value, key) {
            if (value == null) {
                value = _this.defaultFilter[key].toString();
            }
            _this.setState(function (prevState) {
                var _a;
                return {
                    filters: __assign(__assign({}, prevState.filters), (_a = {}, _a[key] = value, _a))
                };
            }, function () {
                if (!_this.searchInProgress) {
                    _this.requestResults();
                }
            });
        };
        _this.reset = function () {
            _this.setState({ filters: _this.defaultFilter }, function () {
                _this.cancelSearch = true;
                _this.props.fetchResults(_this.state.filters.FilterFrom, _this.state.filters.FilterTo, _this.state.filters.ActionFilter, _this.state.filters.AlertFilter);
            });
        };
        _this.requestResults = function () {
            if (_this.searchInProgress) {
                return;
            }
            _this.searchInProgress = true;
            setTimeout(function () {
                if (!_this.delaySearch) {
                    _this.searchInProgress = false;
                    if (!_this.cancelSearch) {
                        _this.props.fetchResults(_this.state.filters.FilterFrom, _this.state.filters.FilterTo, _this.state.filters.ActionFilter == _this.props.applicationData.resources.Filter_All ? 'All' : _this.state.filters.ActionFilter, _this.state.filters.AlertFilter);
                    }
                    else {
                        _this.cancelSearch = false;
                    }
                }
                else {
                    _this.delaySearch = false;
                    _this.searchInProgress = false;
                    _this.requestResults();
                }
            }, 1500);
        };
        _this.delay = function () {
            if (_this.searchInProgress) {
                _this.delaySearch = true;
            }
        };
        _this.defaultFilter = {
            ActionFilter: _this.props.applicationData.resources.Filter_All,
            AlertFilter: false,
            FilterFrom: _this.getDate(-2),
            FilterTo: _this.getDate()
        };
        _this.delaySearch = false;
        _this.searchInProgress = false;
        _this.cancelSearch = false;
        _this.state = {
            filters: _this.defaultFilter
        };
        props.applicationData.availableActions.map(function (action) {
        });
        return _this;
    }
    HistoryFilters.prototype.componentDidMount = function () {
        this.requestResults();
    };
    HistoryFilters.prototype.render = function () {
        var _this = this;
        var date = (new Date()).toISOString().substring(0, 10);
        return (React.createElement(reactstrap_1.Row, null,
            React.createElement(reactstrap_1.Col, null,
                React.createElement(reactstrap_1.Row, null,
                    React.createElement(reactstrap_1.Col, null,
                        React.createElement(reactstrap_date_picker_1.default, { value: this.state.filters.FilterFrom, onClick: this.delay, onChange: function (value) { _this.dateOnChange(value, "FilterFrom"); }, showClearButton: false, minDate: this.getDate(-50, new Date(Date.parse(this.state.filters.FilterFrom))), maxDate: this.state.filters.FilterTo },
                            React.createElement(reactstrap_1.InputGroupAddon, { addonType: "append" },
                                React.createElement(reactstrap_1.InputGroupText, null, this.props.applicationData.resources.FilterFrom)))),
                    React.createElement(reactstrap_1.Col, null,
                        React.createElement(reactstrap_date_picker_1.default, { value: this.state.filters.FilterTo, onClick: this.delay, onChange: function (value) { _this.dateOnChange(value, "FilterTo"); }, showClearButton: false, minDate: this.state.filters.FilterFrom, maxDate: this.getDate() },
                            React.createElement(reactstrap_1.InputGroupAddon, { addonType: "append" },
                                React.createElement(reactstrap_1.InputGroupText, null, this.props.applicationData.resources.FilterFrom))))),
                React.createElement(reactstrap_1.Row, { className: "my-2" },
                    React.createElement(reactstrap_1.Col, null,
                        React.createElement(reactstrap_1.InputGroup, null,
                            React.createElement(reactstrap_1.Input, { type: "select", id: "ActionFilter", onChange: this.onChangeHandler, onClick: this.delay, value: this.state.filters.ActionFilter },
                                React.createElement("option", { key: this.props.applicationData.resources.Filter_All, value: "All" }, this.props.applicationData.resources.Filter_All),
                                this.props.applicationData.availableActions.map(function (action) {
                                    var packAction = new Types_1.PackAction(action.value, action.displayName);
                                    return React.createElement("option", { value: Types_1.PackState.parse(packAction.value).value, key: packAction.value }, packAction.displayName);
                                }),
                                React.createElement("option", { key: Types_1.PackAction.Reactivate.value, value: Types_1.PackState.Active.value }, Types_1.PackAction.Reactivate.displayName)),
                            React.createElement(reactstrap_1.InputGroupAddon, { addonType: "append" },
                                React.createElement(reactstrap_1.InputGroupText, null, this.props.applicationData.resources.ShowBy)))),
                    React.createElement(reactstrap_1.Col, null,
                        React.createElement(reactstrap_1.Row, { className: "fv-c" },
                            React.createElement(reactstrap_1.Col, { md: "auto" }, this.props.applicationData.resources.ShowAlertsOnly),
                            React.createElement(reactstrap_1.Col, null,
                                React.createElement(reactstrap_1.CustomInput, { type: "checkbox", id: "AlertFilter", onClick: this.delay, onChange: this.onChangeHandler, checked: this.state.filters.AlertFilter })),
                            React.createElement(reactstrap_1.Col, null,
                                React.createElement(reactstrap_1.Button, { color: "primary", onClick: this.reset }, this.props.applicationData.resources.CancelScan))))))));
    };
    return HistoryFilters;
}(React.Component));
exports.HistoryFilters = HistoryFilters;
//# sourceMappingURL=HistoryFilters.js.map